import Vue from 'vue';
import router from './router';
import store from './store';
import FindADoctor from './components/FindADoctor.vue';
import ProviderDetails from './components/ProviderDetails.vue';
import Locations from './components/Locations.vue';
import LocationsMap from './components/LocationsMap.vue';
import LocationsListing from './components/LocationsListing.vue';
import Providers from './components/Providers.vue';
import Provider from './components/Provider.vue';

Vue.config.productionTip = false;

window.qhsEvents = new Vue();

document.querySelectorAll('.qhs-elementor').forEach(element => {
    new Vue({
        router,
        store,
        components: {
            FindADoctor,
            ProviderDetails,
            Locations,
            LocationsMap,
            LocationsListing,
            Providers,
            Provider,
        },
    }).$mount(element);
});
